import T from '../components/Translation'

export const isGodMode = (user={}) => user?.userType === "godMode" ? true : false
export const isUser = (user={}) => user?.userType === "user" ? true : false
export const isAdmin = (user={}) => user?.userType === "admin" ? true : false
export const isSuperAdmin = (user={}) => user?.userType === "superAdmin" ? true : false
export const isMindPro = (user={}) => user?.userType === "mindPro" ? true : false

export const NoAccess = () => {
    return (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center"} }>
        <h3>
            <T obj = {{
                it: "Non Avete i permessi necessari per accedere a questa pagina",
                en: "You don't have the permissions to access to this page"
            }}/>
        </h3>

      </div> 
    )
}
